module.exports = __webpack_public_path__ + "static/media/xl-cta-pattern-right-dark.2bfce9a0.svg";